module.exports = __webpack_public_path__ + "img/1c.a807f826.svg";